module.exports = __webpack_public_path__ + "static/rad2-8bdb58e6d5f1d30ffe21c211c72a8245.jpg";